import { defineMessages } from 'react-intl';

export default defineMessages({
    searchResults: {
        id: 'gateway.views.search.Search Results',
        defaultMessage: 'Search Results',
    },
    searching: {
        id: 'gateway.views.search.Searching...',
        defaultMessage: 'Searching...',
    },
    noResultsFoundFor: {
        id: 'ggateway.views.search.No results found for',
        defaultMessage:
            'No result found for "{query}".',
    },
    accountResults: {
        id: 'gateway.views.search.Account Results',
        defaultMessage: 'Accounts ({accountResultsNumber})',
    },
    policyResults: {
        id: 'gateway.views.search.Policy Results',
        defaultMessage: 'Policies ({policyResultsNumber})',
    },
    policyNumber: {
        id: 'gateway.views.search-results.Policy Number',
        defaultMessage: 'POLICY NUMBER',
    },
     account: {
        id: 'gateway.views.search-results.Account',
        defaultMessage: 'ACCOUNT',
    },
    namedInsured: {
        id: 'gateway.views.search-results.Primary Named Insured',
        defaultMessage: 'PRIMARY NAMED INSURED',
    },
    propertyAddress: {
        id: 'gateway.views.search-results.Property Address',
        defaultMessage: 'PROPERTY ADDRESS',
    },
    effectiveDate: {
        id: 'gateway.views.search-results.Effective Date',
        defaultMessage: 'POLICY EFFECTIVE DATE',
    },
    expirationDate: {
        id: 'gateway.views.search-results.Expiration Date',
        defaultMessage: 'POLICY EXPIRATION DATE',
    },
    displayStatus: {
        id: 'gateway.views.search-results.Status',
        defaultMessage: 'STATUS',
    },
    noPolicyNumber: {
        id: 'gateway.views.search-results.Unassigned',
        defaultMessage: 'Unassigned',
    },
    mailingAddress:{
        id: 'gateway.views.search-results.Mailing Address',
        defaultMessage: 'Mailing Address: '
    },
    previous:{
        id: 'gateway.views.search-results.Previous',
        defaultMessage: 'Previous'
    },
    next:{
        id: 'gateway.views.search-results.Next',
        defaultMessage: 'Next'
    }
});
